import { get } from './genericService';

export function getPaymentHistory(link, success, failed) {
  return get(link || '/api/v1/account/payment-history/most-recent', success, failed);
}
